import React from 'react';
import a1 from '../../Assets/106.avif'
import a3 from '../../Assets/402.avif';
import a2 from '../../Assets/401.avif'
import a4 from '../../Assets/108.avif'
import { Link } from 'react-router-dom';

function ImagesCards() {
    const services = [
      {
        _id: 1,
        name: 'School Info',
        img: a1,
        description: '"The beautiful thing about learning is that no one can take it away from you." - B.B. King',
        myText:"Browse the Issues",
        path:"/school"
        
      },
      {
        _id: 2,
        name: 'College Info',
        img: a3,
        description:'"The more that you read, the more things you will know. The more that you learn, the more places you will go." - Dr. Seuss',
        myText:"Take Action",
        path:"/college"
       
      },
      {
        _id: 3,
        name: 'University Info',
        img: a4,
        description: '"The future belongs to those who believe in the beauty of their dreams." - Eleanor Roosevelt',
        myText:"Take Action",
        path:"/university"
       
      },
      {
        _id: 4,
        name: 'Certificate Info',
        img: a2,
        description: '"Skill is the unified force of experience, intellect, and passion in their operation." - John Ruskin',
        myText:"Read Our story",
        path:"/certificate"
        
      },
      ]
  return (
    <div style={{marginTop:'100px'}} className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 pt-6 gap-10">
{
          services.map(service => (
           
       <div style={{alignItems:'center'}} key={service._id} className="card lg:card-side bg-base-100 shadow-xl">
         
            <img src={service.img} style={{height:'350px', width:'400px',objectFit:'fill'}} alt="Album"/>
            <Link to={service.path}>
            <div className="card-body">
               <h2 style={{fontFamily:'raleway',color:'#0E4C92'}} className="px-6 card-title">{service.name}</h2>
               <p style={{fontFamily:'raleway'}} className='px-6 text-sm'>{service.description}</p>
             </div>
            </Link>
         </div>)
)
}


      
    </div>
  )
}

export default ImagesCards
